import React from "react";

const ServeurErrorIcon = ({ style = {}, height = 124, width = 124 }) => (
  <div class="MuiBox-root css-1fpp2g6">
    <h2 class="MuiTypography-root MuiTypography-h2 css-12a5axs-MuiTypography-root">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        enable-background="new 0 0 1920 1080"
        viewBox="0 0 1920 1080"
        id="website-maintenance"
      >
        <g opacity=".1">
          <path
            fill="#2a94f4"
            d="M466.3 715.7c-.7-3.7-1.8-7.3-3.3-10.7-.9-2.1-.6-4.5.9-6.3l6.1-7.5-9.2-11.2-8.5 4.5c-2 1.1-4.5.9-6.4-.4-3.1-2.1-6.4-3.9-9.9-5.3-2.1-.8-3.6-2.8-3.8-5.1l-.9-9.6-14.4-1.4-2.8 9.3c-.7 2.2-2.5 3.8-4.8 4.2-3.7.7-7.3 1.8-10.7 3.3-2.1.9-4.5.6-6.3-.9l-7.5-6.1-11.2 9.2 4.5 8.5c1.1 2 .9 4.5-.4 6.4-2.1 3.1-3.9 6.4-5.3 9.9-.8 2.1-2.8 3.6-5.1 3.8l-9.6.9-1.4 14.4 9.3 2.8c2.2.7 3.8 2.5 4.2 4.8.7 3.7 1.8 7.3 3.3 10.7.9 2.1.6 4.6-.9 6.3l-6.1 7.5 9.2 11.2 8.5-4.5c2-1.1 4.5-.9 6.4.4 3.1 2.1 6.4 3.9 9.9 5.3 2.1.8 3.6 2.8 3.8 5.1l.9 9.6 14.4 1.4 2.8-9.3c.7-2.2 2.5-3.8 4.8-4.2 3.7-.7 7.3-1.8 10.7-3.3 2.1-.9 4.5-.6 6.3.9l7.5 6.1 11.2-9.2-4.5-8.5c-1.1-2-.9-4.5.4-6.4 2.1-3.1 3.9-6.4 5.3-9.9.8-2.1 2.8-3.6 5.1-3.8l9.6-.9 1.4-14.4-9.3-2.8c-2.1-.7-3.8-2.6-4.2-4.8zm-51.8 45.4c-20.2-2-35-20-33-40.2 2-20.2 20-35 40.2-33 20.2 2 35 20 33 40.2-2 20.2-20 34.9-40.2 33z"
          ></path>
          <path
            fill="#2a94f4"
            d="M393.7 722c1.3-13.5 13.3-23.3 26.8-22 13.5 1.3 23.3 13.3 22 26.8-1.3 13.5-13.3 23.3-26.8 22-13.5-1.3-23.3-13.3-22-26.8z"
          ></path>
        </g>
        <ellipse
          cx="914"
          cy="1005.2"
          fill="#2a94f4"
          opacity=".1"
          rx="452.5"
          ry="36.6"
        ></ellipse>
        <path
          fill="#ffbe55"
          d="M776.8 888.5c0 8.5 6.9 15.4 15.4 15.4h553.3c8.5 0 15.4-6.9 15.4-15.4V412.1h-584v476.4z"
          opacity=".19"
        ></path>
        <path
          fill="#ffbe55"
          d="M950.6 691.8c2.6 9 6.2 17.7 10.8 26 2.8 5 2.6 11.2-.6 16l-13.4 20.1 25.7 25.7 20.1-13.4c4.8-3.2 11-3.4 16-.6 8.2 4.6 16.9 8.2 26 10.8 5.5 1.6 9.7 6.1 10.9 11.8l4.7 23.7h36.3l4.8-23.8c1.1-5.6 5.3-10.2 10.9-11.8 9-2.6 17.7-6.2 26-10.8 5-2.8 11.2-2.6 16 .6l20.1 13.4 25.7-25.7-13.4-20.1c-3.2-4.8-3.4-11-.6-16 4.6-8.2 8.2-16.9 10.8-26 1.6-5.5 6.1-9.7 11.8-10.9l23.7-4.7v-36.3l-23.8-4.8c-5.6-1.1-10.2-5.3-11.8-10.9-2.6-9-6.2-17.7-10.8-26-2.8-5-2.6-11.2.6-16l13.4-20.1-25.7-25.7-20.1 13.4c-4.8 3.2-11 3.4-16 .6-8.2-4.6-16.9-8.2-26-10.8-5.5-1.6-9.7-6.1-10.9-11.8l-4.7-23.7h-36.3l-4.8 23.8c-1.1 5.6-5.3 10.2-10.9 11.8-9 2.6-17.7 6.2-26 10.8-5 2.8-11.2 2.6-16-.6L973 536.4l-25.7 25.7 13.4 20.1c3.2 4.8 3.4 11 .6 16-4.6 8.2-8.2 16.9-10.8 26-1.6 5.5-6.1 9.7-11.8 10.9l-23.7 4.7v36.3l23.8 4.8c5.7 1.1 10.3 5.3 11.8 10.9zm118.2-126.1c50.9 0 92.2 41.3 92.2 92.2 0 50.9-41.3 92.2-92.2 92.2-50.9 0-92.2-41.3-92.2-92.2 0-50.8 41.3-92.1 92.2-92.2zM776.8 335.2v46.1h584v-46.1c0-8.5-6.9-15.4-15.4-15.4H792.1c-8.5 0-15.3 6.9-15.3 15.4zm153.7 0h30.7V366h-30.7v-30.8zm-61.5 0h30.7V366H869v-30.8zm-61.5 0h30.7V366h-30.7v-30.8z"
        ></path>
        <path
          fill="#ffbe55"
          d="M1130.3 658c0 33.9-27.5 61.5-61.5 61.5s-61.5-27.5-61.5-61.5c0-33.9 27.5-61.5 61.5-61.5 33.9 0 61.5 27.5 61.5 61.5zM1084.2 58.6c0-8.5-6.9-15.4-15.4-15.4H515.5c-8.5 0-15.4 6.9-15.4 15.4v46.1h584V58.6zM561.6 89.3h-30.7V58.6h30.7v30.7zm61.5 0h-30.7V58.6h30.7v30.7zm61.5 0h-30.7V58.6h30.7v30.7z"
        ></path>
        <path
          fill="#ffbe55"
          d="M746 335.2c0-25.5 20.6-46.1 46.1-46.1h292V135.4h-584v476.4c0 8.5 6.9 15.4 15.4 15.4H746v-292zm123-122.9h30.7V243H869v-30.7zm-61.5 0h30.7V243h-30.7v-30.7zm-61.5 0h30.7V243H746v-30.7zm-61.4 368.8h-123v-30.7h123v30.7zm0-61.5h-123v-30.7h123v30.7zm0-61.4h-123v-30.7h123v30.7zm0-61.5h-123V366h123v30.7zm0-61.5h-123v-30.7h123v30.7zm0-92.2v-30.7h30.7V243h-30.7z"
          opacity=".19"
        ></path>
        <path
          fill="#fcd2b1"
          d="m866.3 767.1.6-16.2 11.5 3.5 2.2 20.2s-11 .7-14.3-7.5z"
        ></path>
        <path
          fill="#0e538c"
          d="M867.3 767.2c2.7 1.1 7.2 2.1 12.8.8l-.7-4.6s3.2 1.9 4 6.1c.8 4.1 1 3 6.2 6.2 5.3 3.2 4.9 10.4 4.9 10.4l-39.2-1s-1.1-7.9 6-16.3c1.4-1.8 3.9-2.5 6-1.6z"
        ></path>
        <path
          fill="#ffbe55"
          d="M804 529s-5.1 19.9 2.1 32.4 20.2-15.2 20.2-15.2S824 519.6 804 529z"
        ></path>
        <path
          fill="#ffe3ca"
          d="M800.4 434.6s-26.4 35.9-30.8 57.6c-4.5 21.7.3 69.1.3 69.1h10.8s5.7-60.5 9.3-69.1c3.6-8.8 27-49.4 27-49.4l-16.6-8.2z"
        ></path>
        <path
          fill="#d3d3d3"
          d="M795.9 784.3h100.2v11.5H795.9zM774.5 863.7h107.7v11.5H774.5zM764.8 940.5h107.7V952H764.8z"
        ></path>
        <path
          fill="#d3d3d3"
          d="M754 1016.9h-12l88.4-415.8h6.7zM879.3 1016.9h-12l70.1-427.5 5.9 2.8z"
        ></path>
        <path
          fill="#f7f7f7"
          d="m855 1016.9 64.5-415.1-89.1-.7-88.4 415.8h-13.8L818 589.4h119.4l-66.3 427.5H853"
        ></path>
        <path
          fill="#fcd2b1"
          d="m814.5 767.1.6-16.2 11.5 3.5 2.2 20.2c-.1 0-11 .7-14.3-7.5z"
        ></path>
        <path
          fill="#ffe3ca"
          d="M928 401.6s28.5-2.1 31.9-15.3c3.4-13.2 2.8-48.8 2.8-48.8h9.9s6.8 33.1 6.4 48.8c-.4 15.7-19.5 42.5-51 40.8-31.4-1.7 0-25.5 0-25.5z"
        ></path>
        <path
          fill="#2a94f4"
          d="M835.7 399.9s-16.5 1.7-23.3 8.9c-3.3 3.5-23.8 28.9-23 34.4l24.1 15 19.7-27.3 2.5-31z"
        ></path>
        <path
          fill="#0b4870"
          d="M809.9 522.2s-7.1 21-.4 44 6.7 69.4 6.1 81.5-11.9 47.1-2.3 108.9h14.8s9-64.8 14.2-92.4c4.9-25.9 11.1-90.5 11.1-90.5s18.6 61.3 15.5 77.1c-3.4 17.4-3.8 105.7-3.8 105.7H880s16.7-76 17.7-96.4c1.1-20.4-1.2-134.8-1.2-134.8s-49.6-33.7-86.6-3.1z"
        ></path>
        <path fill="#fcd2b1" d="m860.7 360-15.1 46.2 27.3 5.4 6-47.9z"></path>
        <path
          fill="#2a94f4"
          d="M876.2 397.3s18.5 3.8 20.4 28c1.9 24.2 4.5 127.4 4.5 136.3-.6 4.1-72.5 17.8-93.9-3-5.4-5.3 12.3-95.1 9.8-118.7-2.6-23.5 11.4-53.4 59.2-42.6z"
        ></path>
        <path
          fill="#2a94f4"
          d="M897.7 445.7s7.4-16.9 30.3-18.6c0 0 5.5-15.7 0-25.5 0 0-41.5-8.5-57.3-5.3s27 49.4 27 49.4z"
        ></path>
        <path
          fill="#ffe3ca"
          d="M972.5 346.4s3.1-16.6-2.4-26c-3.3-5.6-6.9-8.2-10.5-7.2-2.4.7-3.4 4.9-2.8 7.3.8 3.1 3.4 11.6 4.8 14 0 0-2.5 0-5.1-5.6-2.5-5.5-4.4 2.6-2.4 6.4 3 5.5 12.9 20.6 18.4 11.1z"
        ></path>
        <path
          fill="#0e538c"
          d="M815.4 767.2c2.7 1.1 7.2 2.1 12.8.8l-.7-4.6s3.2 1.9 4 6.1c.8 4.1 1 3 6.2 6.2 5.3 3.2 4.9 10.4 4.9 10.4l-39.2-1s-1.1-7.9 6-16.3c1.5-1.8 3.9-2.5 6-1.6z"
        ></path>
        <path
          fill="#0b4870"
          d="M899.4 353.1c-.7-5.8 11.9-9.7-12.2-26.7-12.3-8.6-33.7-4.8-40.3 8.2s-3.1 14.3-8.2 15.2c-5.1 1 .3 41.2 31.1 40.7 30.9-.5 29.6-37.4 29.6-37.4z"
        ></path>
        <path
          fill="#ffbe55"
          d="M805.7 515h93.8c3.8 0 6.9 2.8 7.3 6.5 1.6 14.1 3.3 46.1-13.2 48.4-21.2 3-28-19.9-28-41.2l-61.6.3s-2.1-10.2 1.7-14z"
        ></path>
        <path
          fill="#ffe3ca"
          d="M780 555.7s-1.8 21.3 5.1 27.1c6.9 5.9-12.2 8.5-16.9-2.3s1.7-24.8 1.7-24.8H780z"
        ></path>
        <path
          fill="#ffe3ca"
          d="M778.2 558.5s6.4 1.1 8.8 8c1.4 3.9 2.2 8.1 2.6 11 .3 1.9-1.9 3.2-3.5 2-1.6-1.2-3.1-3-2.9-6.1.5-6.5-7.3-4.6-7.3-4.6s-2.6-7.7 2.3-10.3z"
        ></path>
        <path
          fill="#f7f7f7"
          d="M882.9 529.7H878v-14.5c0-.8.7-1.5 1.5-1.5h2c.8 0 1.5.7 1.5 1.5v14.5zM890.2 529.7h-4.9v-9.6c0-.8.7-1.5 1.5-1.5h2c.8 0 1.5.7 1.5 1.5v9.6zM899.5 529.7h-6.8v-20.9c0-1.1.9-2 2-2h2.8c1.1 0 2 .9 2 2v20.9z"
        ></path>
        <path
          fill="#161616"
          d="M867.2 529.7H905v3.2h-37.8z"
          opacity=".32"
        ></path>
        <path
          fill="#ffbe55"
          d="M557.4 819.5c-1.8-4.6-4-9.1-6.8-13.2-1.7-2.5-1.8-5.8-.4-8.4l6.2-11.2-14.6-12.4-10 8c-2.4 1.9-5.6 2.3-8.4 1-4.5-2-9.3-3.6-14.1-4.5-3-.6-5.4-2.8-6.2-5.7l-3.5-12.2-19.1 1.6-1.5 12.7c-.3 3-2.4 5.6-5.2 6.7-4.6 1.8-9.1 4-13.2 6.8-2.5 1.7-5.8 1.8-8.4.4l-11.2-6.2-12.4 14.6 8 10c1.9 2.4 2.3 5.6 1 8.4-2 4.5-3.6 9.3-4.5 14.1-.6 3-2.8 5.4-5.7 6.2l-12.3 3.5 1.6 19.1 12.7 1.5c3 .3 5.6 2.4 6.7 5.2 1.8 4.6 4 9.1 6.8 13.2 1.7 2.5 1.8 5.8.4 8.4l-6.2 11.2 14.6 12.4 10-8c2.4-1.9 5.6-2.3 8.4-1 4.5 2 9.3 3.6 14.1 4.5 3 .6 5.4 2.8 6.2 5.7l3.5 12.3 19.1-1.6 1.5-12.7c.3-3 2.4-5.6 5.2-6.7 4.6-1.8 9.1-4 13.2-6.8 2.5-1.7 5.8-1.8 8.4-.4l11.2 6.2 12.4-14.6-8-10c-1.9-2.4-2.3-5.6-1-8.4 2-4.5 3.6-9.3 4.5-14.1.6-3 2.8-5.4 5.7-6.2l12.3-3.5-1.6-19.1-12.7-1.5c-3-.4-5.6-2.5-6.7-5.3zM500.8 891c-26.8 2.2-50.3-17.7-52.6-44.5-2.2-26.8 17.7-50.3 44.5-52.6 26.8-2.2 50.3 17.7 52.6 44.5 2.2 26.8-17.7 50.3-44.5 52.6z"
        ></path>
        <path
          fill="#ffbe55"
          d="M464.4 845.2c-1.5-17.9 11.8-33.6 29.6-35.1 17.9-1.5 33.6 11.8 35.1 29.6 1.5 17.9-11.8 33.6-29.6 35.1-17.9 1.5-33.6-11.7-35.1-29.6z"
        ></path>
        <path
          fill="#cce9ff"
          d="M713.1 687.9c-4.8-4.3-10-8.1-15.7-11.2-3.5-1.9-5.5-5.6-5.4-9.5l.5-16.6-24.2-5.6-6.8 15.1c-1.6 3.6-5.1 6-9.1 6.2-6.4.3-12.8 1.4-19 3.2-3.8 1.1-7.9 0-10.6-2.9l-11.3-12.1-21.1 13.1 5.8 15.6c1.4 3.7.6 7.9-2.1 10.8-4.3 4.8-8.1 10-11.2 15.7-1.9 3.5-5.6 5.5-9.5 5.4l-16.6-.5-5.6 24.2 15.1 6.8c3.6 1.6 6 5.1 6.2 9.1.3 6.4 1.4 12.8 3.1 19 1.1 3.8 0 7.9-2.9 10.6l-12.1 11.3 13.1 21.1 15.6-5.9c3.7-1.4 7.8-.6 10.8 2.1 4.8 4.3 10 8.1 15.7 11.2 3.5 1.9 5.6 5.6 5.4 9.5l-.5 16.6 24.2 5.6 6.8-15.1c1.6-3.6 5.1-6 9.1-6.2 6.4-.3 12.8-1.4 19-3.1 3.8-1.1 7.9 0 10.6 2.9l11.3 12.1 21.1-13.1-5.8-15.6c-1.4-3.7-.6-7.9 2.1-10.8 4.3-4.8 8.1-10 11.2-15.7 1.9-3.5 5.6-5.5 9.5-5.4l16.6.5 5.6-24.2-15.1-6.8c-3.6-1.6-6-5.1-6.2-9.1-.3-6.4-1.4-12.8-3.1-19-1.1-3.8 0-7.9 2.9-10.6l12.1-11.3-13.1-21.1-15.6 5.8c-3.7 1.3-7.8.5-10.8-2.1zm-23 116.1c-29.6 18.5-68.6 9.4-87.1-20.2s-9.4-68.6 20.2-87.1 68.6-9.4 87.1 20.2c18.4 29.7 9.4 68.6-20.2 87.1z"
        ></path>
        <path
          fill="#cce9ff"
          d="M620.9 772.6c-12.3-19.7-6.3-45.7 13.5-58 19.8-12.3 45.7-6.3 58 13.5 12.3 19.7 6.3 45.7-13.5 58-19.7 12.3-45.7 6.3-58-13.5z"
        ></path>
        <path
          fill="#ffbe55"
          d="M1412.8 222.4c-3.9 5-7.1 10.4-9.7 16.2-1.6 3.5-5 5.9-8.9 6.1l-16.3.8-3.6 24.1 15.3 5.5c3.6 1.3 6.2 4.6 6.7 8.4.8 6.3 2.3 12.4 4.6 18.3 1.4 3.6.6 7.7-2 10.6l-10.9 12 14.5 19.6 14.8-6.9c3.5-1.6 7.6-1.2 10.7 1.2 5 3.9 10.4 7.1 16.2 9.7 3.5 1.6 5.9 5 6.1 8.9l.8 16.3 24.1 3.6 5.5-15.3c1.3-3.6 4.6-6.2 8.4-6.7 6.3-.8 12.4-2.3 18.3-4.6 3.6-1.4 7.7-.6 10.6 2l12 11 19.6-14.5-6.9-14.8c-1.6-3.5-1.2-7.6 1.2-10.7 3.9-5 7.1-10.4 9.7-16.2 1.6-3.5 5-5.9 8.9-6.1l16.3-.8 3.6-24.1-15.3-5.5c-3.6-1.3-6.2-4.6-6.7-8.4-.8-6.3-2.3-12.4-4.6-18.3-1.4-3.6-.6-7.7 2-10.6l11-12-14.5-19.6-14.8 6.9c-3.5 1.6-7.6 1.2-10.7-1.2-5-3.9-10.4-7.1-16.2-9.7-3.5-1.6-5.9-5-6.1-8.9l-.8-16.3-24.1-3.6-5.5 15.3c-1.3 3.6-4.6 6.2-8.4 6.7-6.3.8-12.4 2.3-18.3 4.6-3.6 1.4-7.7.6-10.6-2l-12-11-19.6 14.5 6.9 14.8c1.5 3.5 1.1 7.6-1.3 10.7zm115.3 13.5c20.3 27.5 14.5 66.4-13 86.7-27.5 20.3-66.4 14.5-86.7-13-20.3-27.5-14.5-66.4 13-86.7 27.6-20.3 66.4-14.5 86.7 13z"
        ></path>
        <path
          fill="#ffbe55"
          d="M1502.8 306c-18.4 13.6-44.2 9.7-57.8-8.7-13.6-18.4-9.7-44.2 8.7-57.8 18.4-13.6 44.2-9.7 57.8 8.7 13.6 18.3 9.7 44.2-8.7 57.8z"
        ></path>
        <path
          fill="#cce9ff"
          d="M1166 141.6c-1.5 8.1-2 16.3-1.7 24.5.2 5-2.3 9.8-6.7 12.3l-18.3 10.5 10.1 30 21-2.7c5-.6 9.9 1.6 12.7 5.7 4.7 6.8 10.1 13 16.1 18.5 3.7 3.4 5.2 8.6 3.9 13.4l-5.5 20.3 28.3 14.1 13-16.7c3.1-4 8.1-5.9 13-5 8.1 1.5 16.3 2.1 24.5 1.7 5-.2 9.8 2.3 12.3 6.7l10.5 18.3 30-10.1-2.7-21c-.6-5 1.6-9.9 5.7-12.7 6.8-4.6 13-10.1 18.5-16.1 3.4-3.7 8.6-5.2 13.4-3.9l20.4 5.5 14.1-28.4-16.8-13c-4-3.1-5.9-8.1-5-13 1.5-8.1 2.1-16.3 1.7-24.5-.2-5 2.4-9.8 6.7-12.3l18.3-10.5-10.1-30-21 2.7c-5 .6-9.9-1.6-12.7-5.7-4.6-6.8-10.1-13-16.1-18.5-3.7-3.4-5.2-8.6-3.9-13.4l5.5-20.4-28.2-14.1-13 16.7c-3.1 4-8.1 5.9-13 5-8.1-1.5-16.3-2.1-24.5-1.7-5 .2-9.8-2.3-12.3-6.7l-10.5-18.3-30 10.1 2.7 21c.6 5-1.6 9.9-5.7 12.7-6.8 4.6-13 10.1-18.5 16.1-3.4 3.7-8.6 5.2-13.4 3.9l-20.4-5.5-14.1 28.4 16.7 13c4.1 3.1 6 8.1 5 13.1zm141.3-52.7c39.8 19.8 56 68.1 36.3 107.9-19.8 39.8-68.1 56-107.9 36.3-39.8-19.8-56-68.1-36.3-107.9 19.8-39.8 68.1-56 107.9-36.3z"
        ></path>
        <path
          fill="#cce9ff"
          d="M1319.5 184.9c-13.2 26.5-45.4 37.4-71.9 24.2-26.5-13.2-37.4-45.4-24.2-71.9 13.2-26.5 45.4-37.4 71.9-24.2 26.6 13.1 37.4 45.3 24.2 71.9z"
        ></path>
      </svg>
    </h2>
    <h3 class="MuiTypography-root MuiTypography-h3 css-gge8r6-MuiTypography-root">
      Une erreur inconnue est survenue, veuillez réessayer plus tard ou
      contacter le service clientèle.
    </h3>
  </div>
);

export default ServeurErrorIcon;
